class Elementor_Awards{
    static instance;

    static getInstance() {
        if (!Elementor_Awards.instance) {
            Elementor_Awards.instance = new Elementor_Awards();
        }
        return Elementor_Awards.instance;
    }
    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-awards.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Awards.getInstance();